import { formatISO } from "date-fns";
import { ICategoria } from "./ICategoria";
import { IConteudo } from "./IConteudo";

export interface INoticia {
  id: number;
  categoria: ICategoria;
  titulo: string;
  conteudo: IConteudo[];
  imagem: string;
  video: string;
  data: string;
  autor: string;
  cidade: string;
  slug?: string;
}

export interface INoticiaPost {
  titulo: string;
  imagem: string;
  video: string;
  autor: string;
  cidade: string;
  categoria: { id: number };
  conteudo: IConteudo[];
}

export function todayDate() {
  const date = new Date();
  const isoString = formatISO(date, { representation: "complete" });
  const offset = "-03:00";
  return isoString + offset;
}
export const placeholderNoticia: INoticia = {
  id: 0,
  autor: "",
  cidade: "",
  titulo: "",
  conteudo: [{ paragrafo: "", subtitulo: "", imagem: "" }],
  imagem: "",
  data: todayDate(),
  slug: "",
  video: "",
  categoria: {
    id: 0,
    nome: "",
  },
};
